import { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import Loader from 'components/Loader';
import { WebhookDeliveriesTable } from 'components/WebhookDeliveries/WebhookDeliveriesTable';
import { getTransactionWebhookDeliveriesRequest } from 'services/requestAgent';
import Button from 'uikit/Button/Button';
import './WebhooksTab.scss';

// Webhook deliveries of the transaction; the response already contains attempts and payloads
const WebhooksTab = ({ transactionNumber }) => {
  const i18n = useContext(i18nContext);
  const [deliveries, setDeliveries] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const loadDeliveries = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      setDeliveries(await getTransactionWebhookDeliveriesRequest(transactionNumber));
    } catch (err) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [transactionNumber]);

  useEffect(() => {
    loadDeliveries();
  }, [loadDeliveries]);

  if (deliveries === null && isLoading) {
    return <Loader className={'application-loader transaction-webhooks-loader'} />;
  }

  return (
    <div className={'transaction-webhooks-tab'}>
      <div className={'transaction-webhooks-actions'}>
        <Button
          className={'transaction-webhooks-refresh'}
          roleType={'button'}
          size={'small'}
          type={'outline'}
          onClick={loadDeliveries}
          isDisabled={isLoading}
        >
          {i18n.getMessage('webhookTab.history.button.refresh')}
        </Button>
      </div>
      {isError ? (
        <p className={'transaction-webhooks-error'}>{i18n.getMessage('webhookDeliveries.loadError')}</p>
      ) : (
        <WebhookDeliveriesTable deliveries={deliveries || []} />
      )}
    </div>
  );
};

WebhooksTab.propTypes = {
  transactionNumber: PropTypes.string
};

export default WebhooksTab;
